import React, { useContext, useState, ReactNode } from "react";

export interface User {
  access: string;
  access_token?: string;
  refresh?: string;
  id: string;
  user_id: string;
  username: string;
  permissions: string[];
  roles: string[];
  employee_id?: string;
  admin_unit?: string;
  org_unit?: string;
  user_type: string;
  is_superuser?: boolean;
  full_name: string;
  user?: User;
  stack_holder_name?: string;
  stakeholder?: any;
  email?: string;
first_name?: string;
  last_name?: string;
  uu_id?: string;
  org_unit_id?: string;
  org_phone_number?: string;
  organization?: any;

  deputy_id?: string;
}

interface AuthState {
  user: User;
  token: string;
}

type UpdateAuth = (auth: AuthState) => void;

// Provide default values (optional safe fallback values)
const defaultUser: User = {
  access: "",
  user_id: "",
  id: "",
  username: "",
  permissions: [],
  roles: [],
  employee_id: "",
  admin_unit: "",
  org_unit: "",
  user_type: "",
  is_superuser: false,
full_name: "",
  first_name: "",
  last_name: "",
  deputy_id: "",
};

// Create contexts
const AuthContext = React.createContext<AuthState>({
  user: defaultUser,
  token: "",
});

const AuthUpdateContext = React.createContext<UpdateAuth>(() => {});

// Custom hooks
export function useAuth() {
  return useContext(AuthContext);
}

export function useAuthUpdate() {
  return useContext(AuthUpdateContext);
}

// Provider
export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>({
    user: defaultUser,
    token: "",
  });

  const updateAuth: UpdateAuth = (auth) => {
    setState(auth);
  };

  return (
    <AuthContext.Provider value={state}>
      <AuthUpdateContext.Provider value={updateAuth}>
        {children}
      </AuthUpdateContext.Provider>
    </AuthContext.Provider>
  );
}

